<template>
    <div class="trend-search-wrap">
<!--        <div class="trend-search-tip"><i class="el-icon-info" />各条件组之间为或的关系，条件组内各条件为且的关系</div> 移除或逻辑注释 -->
        <trend-search-group v-for="(group, index) in groupArray" :index="index + 1" :key="group[0] && (group[0].id  || group[0].labelQueryId)" :group="group">
<!--            <span @click="delGroup(index)"><i class="el-icon-delete" />删除条件组</span> 移除或逻辑注释 -->
        </trend-search-group>
<!--        <div v-if="!readOnly" class="trend-search-add" @click="addGroup"> 移除或逻辑注释 -->
        <div v-if="groupArray.length < 1" class="trend-search-add" @click="addGroup">
            <i class="el-icon-circle-plus-outline trend-search-add-icon" />
            添加条件组
        </div>
    </div>
</template>

<script>
    import TrendSearchGroup from "./TrendSearchGroup";
    export default {
        name: "TrendSearch",
        props: {
            ledgerId: [String, Number],
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        components: {
            TrendSearchGroup
        },
        provide () {
            return {
                fieldMap: () => this.fieldMap,
                readOnly: () => this.readOnly
            }
        },
        data() {
            return {
                groupArray: [],
                fieldList: [],
                fieldMap: {}
            }
        },
        created() {
            this.getListFields()
        },
        methods: {
            setGetGroup (flat) {
                this.groupArray = flat
            },
            getSqlByGroup () {
                if (this.groupArray.length < 1) return ''
                let sql = 'AND ('
                this.groupArray.forEach((item, index) => {
                    if (index === 0) sql += '('
                    else sql += ' OR ('
                    item.forEach((cla, ci) => {
                        cla.queryGroup = index + 1
                        if (ci === 0) sql += cla.querySql
                        else sql += ' AND ' + cla.querySql
                        if (ci === item.length - 1) {
                            sql += ')'
                        }
                    })
                })
                return (sql += ')')
            },
            setQueryGroup () {
                if (this.groupArray.length < 1) return ''
                this.groupArray.forEach((item, index) => {
                    item.forEach(cla => {
                        cla.queryGroup = index + 1
                    })
                })
            },
            getGroupFlat () {
                this.setQueryGroup()
                return {
                    // querySql: this.getSqlByGroup(),
                    // conds: this.groupArray 移除或逻辑注释
                    conds: this.groupArray[0] || []
                }
            },
            delGroup (index) {
                this.groupArray.splice(index, 1)
            },
            addGroup () {
                this.groupArray.push([{
                    id: Date.now(),
                    fieldDicKey: "",
                    fieldDicKeyInputFormat: "",
                    fieldInputType: "",
                    fieldName: "",
                    queryField: "",
                    fieldCondKey: "",
                    fieldValue: "",
                    queryGroup: "",
                    fieldGroup: "",
                    querySql: ""
                }])
            },
            async getListFields () {
                const { data } = await this.$http.get(`/api/dynamicLedgerManages/listFieldsOfPageQuery/${this.ledgerId}`)
                this.fieldList = data.data
                const map = {}
                this.fieldList.forEach(field => { map[field.fieldModelId] = field })
                this.fieldMap = map
            }
        }
    }
</script>

<style lang="scss">
    .trend-search-wrap {
        .trend-search-tip {
            font-size: 12px;
            padding: 5px 0 10px;
            > i {
                color: #2e80fc;
                margin-right: 5px;
            }
        }
        .trend-search-add {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 134px;
            border-radius: 8px;
            border: 1px dashed #E2E2E8;
            box-sizing: border-box;
            cursor: pointer;
            .trend-search-add-icon {
                color: rgba(230, 65, 23, 1);
                margin-right: 8px;
            }
        }
    }
</style>
